const KNOWN_DOMAINS = ['tagada.io', 'tagada.dev', 'tagadapay.com', 'tagadapay.dev'];

/**
 * Get the root domain for building CDN hostnames (e.g. *.cdn.tagada.io).
 * Priority: VITE_CDN_DOMAIN env var > hostname detection > localhost fallback
 */
export function getCdnDomain(): string {
    if (import.meta.env.VITE_CDN_DOMAIN) {
        return import.meta.env.VITE_CDN_DOMAIN;
    }

    if (typeof window !== 'undefined') {
        const { hostname } = window.location;

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'localhost:5173';
        }

        const match = KNOWN_DOMAINS.find(d => hostname.includes(d));
        if (match) return match;
    }

    return 'localhost:5173';
}

/**
 * Get the protocol based on the domain
 */
export function getProtocol(domain: string): string {
    return domain.includes('localhost') ? 'http' : 'https';
}

/**
 * Build a CDN URL for a given identifier (alias or instance ID)
 */
export function buildCdnUrl(identifier: string, storeId: string, basePath: string = '/'): string {
    const domain = getCdnDomain();
    const protocol = getProtocol(domain);
    return `${protocol}://${identifier}--${storeId}.cdn.${domain}${basePath}`;
}

/**
 * Build a direct instance CDN URL
 */
export function buildInstanceCdnUrl(instanceId: string): string {
    const domain = getCdnDomain();
    const protocol = getProtocol(domain);
    return `${protocol}://${instanceId}.cdn.${domain}/`;
}

